export default "__VITE_ASSET__78b3c205__"